export const EMPTY_FILTERS = {
  reference: "",
  date_from: "",
  date_to: "",
  value_min: "",
  value_max: "",
  buildings_min: "",
  buildings_max: "",
  co2_min: "",
  co2_max: "",
};

export const FIELDS = [
  {
    k: "reference",
    label: "Référence",
    type: "search",
    wide: true,
    placeholder: "Rechercher une référence",
    maxLength: 255,
  },
  { k: "date_from", label: "Date du", type: "date" },
  { k: "date_to", label: "Date au", type: "date" },
  { k: "value_min", label: "Coût min (€)", type: "number", min: 0 },
  { k: "value_max", label: "Coût max (€)", type: "number", min: 0 },
  { k: "buildings_min", label: "Bâtis min", type: "number", min: 0, step: 1 },
  { k: "buildings_max", label: "Bâtis max", type: "number", min: 0, step: 1 },
  { k: "co2_min", label: "CO₂ min (t)", type: "number", min: 0 },
  { k: "co2_max", label: "CO₂ max (t)", type: "number", min: 0 },
];

export const SORTS = [
  { id: "fire_date", label: "Date" },
  { id: "buildings_saved", label: "Bâtis préservés" },
  { id: "co2_saved_t", label: "Puits de CO₂" },
  { id: "preserved_value_eur", label: "Coût des sauvés" },
];